import type { EducationalAdvisorBatchStudio } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveEducationalAdvisorBatchStudios = createApiThunk<EducationalAdvisorBatchStudio[], void>(
  "educationalAdvisor/retrieve-batch-studios",
  async (_: void, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.listBatchStudios();
  },
);
